import  gql  from 'graphql-tag'

export const financialObligationTypes = gql`query financialObligationTypes($isActive: Boolean){ 
    financialObligationTypes(isActive:$isActive){
            edges{
                node{
                    id,
                    code,
                    name,
                    isActive
                }
            }
        }
    }`;
